import { createCommand } from '@commander-js/extra-typings';
import type { AstroCommandServices } from '@wix/cli-command-contract';
import { skillsAddCommand } from './skills-add.js';
import { skillsUpdateCommand } from './skills-update.js';

export const skillsCommand = (
  services: AstroCommandServices,
  cliVersion: string
) => {
  return createCommand('skills')
    .description('Manage Wix skills')
    .addCommand(skillsAddCommand(services, cliVersion))
    .addCommand(skillsUpdateCommand(services, cliVersion));
};
